import React, { useState } from "react";
import { toast } from "react-toastify";
import { useStore } from "effector-react";
import { useHistory } from "react-router-dom";
import { Preloader } from "../../../common/ui/Preloader/preloader";
import {
  IAccount,
  queryNewAccount,
  queryAccountsChange,
  $accounts,
  queryAccounts,
  updateAccount,
  AddChargesToAccount,
  AddOwnerTypeToAccount,
  AccountsDoneLoading,
} from "../../../common/accounts2";

import "react-toastify/dist/ReactToastify.css";
import { getCustomUserAgent, getCustomUserAgentASB, getCustomUserAgentKrk } from "../../../common/customUserAgent";
import { $SiteColors } from "../../../common/config/company-atts";
toast.configure();

interface INewAccountKrkOrganization {
  setNewAccount: React.Dispatch<React.SetStateAction<IAccount | null>>;
  onCancelClicked: () => void;
  comid: string;
  hideAnon: boolean;
  onAnonClicked: () => void;
  isValid: boolean;
  setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
  disableWhileLoading: boolean;
  setDisableWhileLoading: React.Dispatch<React.SetStateAction<boolean>>;
  redirectTo: string;
}

export const NewAccountKrkOrganization = ({
  setNewAccount,
  onCancelClicked,
  comid,
  hideAnon,
  onAnonClicked,
  isValid,
  setIsValid,
  disableWhileLoading,
  setDisableWhileLoading,
  redirectTo,
}: INewAccountKrkOrganization) => {
  const [values, setValues] = React.useState({
    account: "",
    inn: "",
    kpp: "",
    companyId: comid.toString(),
  });

  const form = React.useRef<HTMLFormElement>(null);
  const history = useHistory();
  const { accounts } = useStore($accounts);

  const [kppRequired, setKppRequired] = useState(true)

  React.useEffect(() => {
    if (form.current) setIsValid(form.current.checkValidity());
  }, [values]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    if (name == "inn") setKppRequired(value.length < 11)
    setValues({ ...values, [name]: value });
  };

  const handleFormSubmitAccount = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const newData = { accParams: values }
    setDisableWhileLoading(true);
    setIsValid(false);
    queryNewAccount({
      data: newData,
      setNewAccount,
      setDisableWhileLoading,
      setIsValid,
    })
      .then((res) => {
        queryAccounts()
          .then(async res => {
            var bar = new Promise((resolve, reject) => {
              res.accounts.forEach(async (elem, index) => {
                await updateAccount({ account: elem, accounts: res.accounts });
                  await AddChargesToAccount({ account: elem, accounts: res.accounts })
                if (getCustomUserAgent() === getCustomUserAgentKrk()
                  // ||getCustomUserAgent() === getCustomUserAgentASB()
                ) {
                  await AddOwnerTypeToAccount({ account: elem, accounts: res.accounts })
                }
                if (index === res.accounts.length - 1) resolve("@");
              })
            })
            bar.then(() => {
              AccountsDoneLoading()
            }).finally(() => {
              AccountsDoneLoading()
            })
            // queryAccountsChange(accounts.concat(res));
          })
      })
      .then(() => history.push(redirectTo))
      .catch((err) => {
        console.log("ON_NEW_ACCOUNT", err.message)



        toast.error(err.message);
        setNewAccount(null);
        setDisableWhileLoading(false);
        setIsValid(true);
      });
  };

  return (
    <form
      className="login__form addacc__form"
      ref={form}
      onSubmit={handleFormSubmitAccount}
    >
      <input
        type="text"
        className="login__input addacc__input"
        placeholder="Введите номер договора"
        name="account"
        required
        id="account"
        maxLength={30}
        autoComplete="off"
        value={values.account}
        onChange={handleChange}
        disabled={disableWhileLoading}
      ></input>
      <input
        type="text"
        className="login__input addacc__input"
        placeholder="Введите ИНН"
        name="inn"
        required
        id="inn"
        maxLength={30}
        autoComplete="off"
        value={values.inn}
        onChange={handleChange}
        disabled={disableWhileLoading}
      ></input>
      <input
        type="text"
        className="login__input addacc__input"
        placeholder="Введите КПП"
        name="kpp"
        required={kppRequired}
        id="kpp"
        maxLength={30}
        autoComplete="off"
        value={values.kpp}
        onChange={handleChange}
        disabled={disableWhileLoading}
      ></input>
      <div className="addacc__buttons addacc__buttons_space">
        <button
          type="submit"
          className="addacc__button addacc__button_decision addacc__button_decision_submit"
          style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }}
          disabled={!isValid}
        >
          {disableWhileLoading ? <Preloader small={true} /> : "Добавить"}
        </button>
        {hideAnon ? (
          <button
            onClick={onCancelClicked}
            className="addacc__button addacc__button_decision addacc__button_decision_cancel"
            disabled={disableWhileLoading}
            type="button"
          >
            Отмена
          </button>
        ) : (
          <button
            hidden={hideAnon}
            className="addacc__button addacc__button_decision addacc__button_decision_anonim"
            onClick={onAnonClicked}
            disabled={disableWhileLoading}
            type="button"
          >
            Анонимный вход
          </button>
        )}
      </div>
    </form>
  );
};
